export default {
    
    urlApi: 'http://api.enlacejuridicoacademico.com/'
    // urlApi: 'http://localhost:8888/GitHub/api-eja/'
};